import { cloneDeep } from 'lodash';
import { Note, Production } from 'sr-types/lib/search/v1/graphql';

export const getItemsWithNewStatusNote = (item: Production, productionId: string, note: Note) => {
    if (item.id !== productionId) return item;

    const clonedNote = note ? cloneDeep(note) : null;
    return {
        ...item,
        currentStatusNote: clonedNote,
        currentStatusNoteReference: clonedNote?.reference || (clonedNote?.id ? { id: clonedNote.id } : null)
    };
};
